import React from "react";
import {ErrorCommon, TextField, TextFieldCommon} from "../../../components/formikFormInputs";
import {Checkbox, FormControlLabel, Grid, Link} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {Label} from "../../formInputs";
import Recaptcha from "./ReCaptcha";
import {useFormikContext} from "formik";
import {isAdmin} from "../../navigation/AdminNavigation";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";


function PaymentNotes(props: any) {
    const {agreementText} = props;
    const {user} = useSelector((state: RootState) => state.auth);
    const isServicing = user && user.accessType === "client" && user.demoClientId
    const {values, handleChange, handleBlur, errors, touched} = useFormikContext();
    const disabled = isAdmin(user) || !!isServicing
    const fieldObj = [
        {
            name: "notes",
            id: "notes",
            label: <Label label={"Write any optional notes here"} required={true}/>,
            placeholder: "Write any optional notes here",
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            multiline: true,
            rows: 4,
            disabled: (disabled)
        },
    ];
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <span className="hLine"/>
                <Typography variant="body1" component="strong" className="floatLeft w100 mb0">Notes</Typography>
                <Typography variant="caption" className="floatLeft w100 mb0">Leave any specific notes for our processing
                    team.</Typography>
            </Grid>
            <Grid item xs={12}>
                    {
                        fieldObj.map((field, index) => {
                            return (
                                    <div className="mt30" key={index}>
                                        <TextFieldCommon
                                                {...field}
                                                values={values}
                                                onChange={handleChange}
                                        />
                                        <ErrorCommon errors={errors} name={field.name}
                                                        touched={touched}/>
                                    </div>
                            );
                        })
                    }
            </Grid>
            <Grid item xs={12}>
                <span className="hLine"/>
                <FormControlLabel className="mb0 floatLeft w100" control={
                    <Checkbox className="pt0 mb0" name="agreed" color="primary" onChange={handleChange} disabled={disabled}/>
                } label={<Typography variant="caption" className="mb0 floatLeft">{agreementText}</Typography>}/>
                <ErrorCommon errors={errors}
                             name={"agreed"}
                             touched={touched}/>

            </Grid>

            {/*<Grid item xs={12}>*/}
            {/*    <Recaptcha/>*/}
            {/*</Grid>*/}
        </Grid>
    );
}

export default PaymentNotes;